/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEventDto } from '../models/work-create-event-dto';
import { WorkEvent } from '../models/work-event';
import { WorkUpdateEventDto } from '../models/work-update-event-dto';

@Injectable({ providedIn: 'root' })
export class WorkEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventsV1ControllerFindAll()` */
  static readonly EventsV1ControllerFindAllPath = '/v1/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEvent>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsService.EventsV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEvent>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEvent>> {
    return this.eventsV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEvent>>): Array<WorkEvent> => r.body)
    );
  }

  /** Path part for operation `eventsV1ControllerCreate()` */
  static readonly EventsV1ControllerCreatePath = '/v1/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV1ControllerCreate$Response(
    params: {
      body: WorkCreateEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsService.EventsV1ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV1ControllerCreate(
    params: {
      body: WorkCreateEventDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.eventsV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `eventsV1ControllerFindById()` */
  static readonly EventsV1ControllerFindByIdPath = '/v1/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV1ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV1ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsService.EventsV1ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV1ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV1ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.eventsV1ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `eventsV1ControllerUpdate()` */
  static readonly EventsV1ControllerUpdatePath = '/v1/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV1ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsService.EventsV1ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV1ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEventDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventsV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
